import { loadBookingFlow } from "./bookingFlowStorage";

/** Routes for admin PartyBoss slot booking when session draft has {@code adminBooking}. */
export function getAdminBookingPaths() {
  const draft = loadBookingFlow();
  if (!draft?.adminBooking) return null;
  return {
    form: "/admin/partyboss-slot-booking",
    addons: "/admin/partyboss-slot-booking/addons",
    review: "/admin/partyboss-slot-booking/review",
  };
}
